<template>
  <div class="achievements-item" :class="result.count?'':'blur'">
    <span class="achievements-item__label" v-if="result.count">
      {{result.count}}x
    </span>
    <p class="achievements-item__icon" v-html="result.icon"></p>
    <h6 class="achievements-item__title">{{result.name}}</h6>
    <p class="achievements-item__text">{{result.description}}</p>
  </div>
</template>

<script>
export default {
  name: 'AchievementsItem',
  props: ['result'],
}
</script>
<style lang="scss" >
.achievements-item {
  &__icon{
    >* {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
<style lang="scss" scoped>
.achievements-item {
  position: relative;
  border: 2px solid transparent;
  border-radius: 6px;
  padding: 51px 35px 27px;
  text-align: center;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
  transition: .2s linear border-color;
  &.blur {
    filter: grayscale(1);
  }

  &__label{
    display: flex;
    align-items: center;
    position: absolute;
    top: 15px;
    right: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    padding: 1px 10px;
    background: #00A59E;
    border-radius: 6px;
    opacity: 0;
    transition: .2s linear opacity;
  }
  &:not(.blur):hover{
    border-color: #00A59E;
    .achievements-item__label{
      opacity: 1;
    }
  }
  &__icon{
    margin-bottom: 25px;
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #252425;
    margin-bottom: 3px;
    max-width: 180px;
  }
  &__text{
    //font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }
}
</style>